var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenutemplates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_356_118)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10 17.0601C10.8846 17.8519 12.0527 18.3333 13.3333 18.3333C16.0948 18.3333 18.3333 16.0947 18.3333 13.3333C18.3333 11.0275 16.7726 9.08627 14.6499 8.50842",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34999 8.50843C3.22728 9.08627 1.6665 11.0275 1.6665 13.3333C1.6665 16.0947 3.90508 18.3333 6.6665 18.3333C9.42793 18.3333 11.6665 16.0947 11.6665 13.3333C11.6665 12.6829 11.5423 12.0615 11.3164 11.4915M14.9998 6.66663C14.9998 9.42805 12.7613 11.6666 9.99984 11.6666C7.23841 11.6666 4.99984 9.42805 4.99984 6.66663C4.99984 3.9052 7.23841 1.66663 9.99984 1.66663C12.7613 1.66663 14.9998 3.9052 14.9998 6.66663Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_356_118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenutemplates);
export default __webpack_public_path__ + "static/media/menutemplates.0add241f57a98c1c693dc565e82eef19.svg";
export { ForwardRef as ReactComponent };